import React from "react";
import contactImage from "../../assets/images/community.jpg"; // Replace with your image path

const Contact = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="bg-pink-100 py-20">
        <div className="container mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          {/* Text */}
          <div>
            <h1
              className="text-5xl font-bold text-pink-600 mb-6"
              style={{ fontFamily: "Barlow Semi Condensed" }}
            >
              Contact Pink Help
            </h1>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              We’d love to hear from you. Whether you're a woman in need, a
              professional who wants to partner, or a brand looking to make an
              impact — Pink Help is here for you.
            </p>
            <p className="text-md text-gray-700 leading-relaxed">
              Reach out to us through the form, email, or connect with our
              representatives in your country. Together, let’s build a
              world where women are seen, supported, and empowered.
            </p>
          </div>

          {/* Image */}
          <div className="mt-16">
            <img
              src={contactImage}
              alt="Contact Pink Help"
              className="rounded-3xl shadow-lg"
            />
          </div>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="bg-white py-20">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-pink-600 mb-6">
            Send Us a Message
          </h2>
          <p className="text-lg text-gray-700 mb-10 max-w-2xl mx-auto">
            Fill out the form below and someone from our global team will be in
            touch within 24–48 hours.
          </p>

          <form className="bg-pink-50 max-w-3xl mx-auto p-8 rounded-xl shadow-md space-y-5 text-left">
            <div className="grid md:grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="Your Name"
                className="p-3 w-full border border-gray-300 rounded"
                required
              />
              <input
                type="email"
                placeholder="Email Address"
                className="p-3 w-full border border-gray-300 rounded"
                required
              />
            </div>
            <input
              type="text"
              placeholder="Country"
              className="p-3 w-full border border-gray-300 rounded"
            />
            <input
              type="text"
              placeholder="Subject"
              className="p-3 w-full border border-gray-300 rounded"
            />
            <textarea
              placeholder="Your Message"
              className="p-3 w-full border border-gray-300 rounded"
              rows={5}
              required
            ></textarea>
            <button
              type="submit"
              className="bg-pink-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-pink-700 transition"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Contact;
